module.exports = __webpack_public_path__ + "img/img_hello_view.6b4f0928.png";